/* ============================================================
   handpanladen · Home — ES-Modul
   Reveal-on-scroll · Klang-Play (Platzhalter) · Mobile-Sticky-CTA
   Kein jQuery, keine Impact-Originale angefasst. Idempotent.
   ============================================================ */

const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function initReveal() {
  const reveals = Array.from(document.querySelectorAll('.hpl-lp .reveal:not([data-hpl-revealed])'));
  if (!reveals.length) return;

  if (REDUCE || !('IntersectionObserver' in window)) {
    reveals.forEach((el) => {
      el.classList.add('is-in');
      el.setAttribute('data-hpl-revealed', '');
    });
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  reveals.forEach((el) => {
    el.setAttribute('data-hpl-revealed', '');
    io.observe(el);
  });
}

/* Klang-Platzhalter: bis echte Audio-Files da sind, nur visuelles
   Feedback + Hinweis. Echte Files → <audio> hinter denselben Buttons. */
function initSoundModes() {
  const groups = document.querySelectorAll('.hpl-lp [data-hpl-sound-modes]:not([data-hpl-bound])');
  groups.forEach((group) => {
    group.setAttribute('data-hpl-bound', '');
    const modes = Array.from(group.querySelectorAll('[data-hpl-mode]'));
    modes.forEach((btn) => {
      btn.addEventListener('click', () => {
        const wasPlaying = btn.classList.contains('playing');
        modes.forEach((b) => b.classList.remove('playing'));
        if (!wasPlaying) btn.classList.add('playing');
      });
    });
  });
}

function initHeroPlay() {
  const buttons = document.querySelectorAll('.hpl-lp [data-hpl-hero-play]:not([data-hpl-bound])');
  buttons.forEach((btn) => {
    btn.setAttribute('data-hpl-bound', '');
    btn.addEventListener('click', () => {
      const cap = btn.parentElement && btn.parentElement.querySelector('[data-hpl-hero-caption]');
      if (cap) cap.textContent = cap.getAttribute('data-hpl-pending') || cap.textContent;
    });
  });
}

/* Mobile Sticky-CTA: einblenden, sobald der Hero aus dem Viewport scrollt. */
function initSticky() {
  const sticky = document.querySelector('.hpl-lp .hpl-sticky:not([data-hpl-bound])');
  if (!sticky || !('IntersectionObserver' in window)) return;
  const anchor = document.querySelector('.hpl-lp [data-hpl-hero]');
  if (!anchor) return;

  sticky.setAttribute('data-hpl-bound', '');
  const so = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      sticky.classList.toggle('show', !e.isIntersecting);
    });
  }, { threshold: 0 });
  so.observe(anchor);
}

function init() {
  initReveal();
  initSoundModes();
  initHeroPlay();
  initSticky();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}

/* Theme-Editor: bei Section-Neuladen erneut binden. */
document.addEventListener('shopify:section:load', init);
